<template>
  <div class="record-chart">
    <div class="record-table">
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        height="250"
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { chartColumns } from './index.js';
  export default {
    name: 'ApprovalRecordChart',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        columnList: [],
        load: false,
      };
    },
    mounted() {
      this.columnList = chartColumns;
    },
    methods: {
      fullTableData(tableData) {
        this.tableData = tableData;
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .record-chart {
    background: #fff;

    .record-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
